<template>
<section class="mb-5">
    <h3 class="section-title">Patents</h3>
    <ul class="right-list">
        <div>
            <ul class="tech-list">
                <li style="margin-right: 0.5rem;" v-for="(patent,index) in patentsInfo" :key="index">
                    {{ patent.id }} 
                    <span style="font-style: italic;">{{patent.title}}</span>
                    {{" - " + patent.authors}}
                </li>
            </ul>
        </div>
    </ul>
</section>
</template>

<script>
export default {
    props:{
        patentsInfo:{
            type: Object
        }
    }
}
</script>

<style>

</style>
